<template>
	<vxe-modal v-model="showFlag" title="删除NB采集器指令" :destroy-on-close="true" :esc-closable="true" width="50%">
		<vxe-table  align="center" :data="list"  border height="450"   ref="mTable"
						  resizable highlight-hover-row :loading="loading" size="mini">
			<vxe-table-column type="seq" width="50"></vxe-table-column>
			<vxe-table-column title="采集器地址" field="collector_addr"  show-overflow="title"></vxe-table-column>
			<vxe-table-column title="指令类型" field="command_type" show-overflow="title" :formatter="getCommandtype"></vxe-table-column>
			<vxe-table-column title="指令参数" field="command_param" show-overflow="title"></vxe-table-column>
			<vxe-table-column title="指令状态" field="command_state"  show-overflow="title" :formatter="getCommandState"></vxe-table-column>
			<vxe-table-column title="创建时间" field="create_time"  show-overflow="title" width="140" :formatter="getTimeFormatter"></vxe-table-column>
			<vxe-table-column title="更新时间" field="update_time" show-overflow="title" width="140" :formatter="getTimeFormatter"></vxe-table-column>
			<vxe-table-column title="操作" field="id" width="120">
				<template #default="{ row }">
					<a-popconfirm title="确定要删除该条指令?" ok-text="确定" cancel-text="取消" placement="bottom" @confirm="deleteContent(row)">
						<a-button size="small"  type="link">删除</a-button>
					</a-popconfirm>
				</template>
			</vxe-table-column>
		</vxe-table>
	</vxe-modal>
</template>

<script>
	export default {
		data() {
			return {
				showFlag: false,
				loading:false,
				list:[],
			}
		},
		methods: {
			deleteContent(row){
				let param = {theId:row.id};
				let url = this.Api.getLastUrl(this.Api.DELETE_NB_COLLECTOR_COMMAND_ID_URL);
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.queryNBCommand(row.collector_addr);
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
					this.loading = false;
				});
			},
			getCommandtype({cellValue}){
				var str  = "";
				if(cellValue != null){
					switch(cellValue){
						case "0":{
							str = "下发地址";
						}
						break;
						case "2":{
							str = "设置工作模式";
						}
						break;
						case "3":{
							str = "设置上报日期";
						}
						break;
					}
				}
				return str;
			},
			getCommandState({cellValue}){
				var str  = "";
				if(cellValue != null){
					switch(cellValue){
						case "0":{
							str = "已创建";
						}
						break;
						case "1":{
							str = "执行中";
						}
						break;
						case "2":{
							str = "已完成";
						}
						break;
						case "3":{
							str = "执行异常";
						}
						break;
					}
				}
				return str;
			},
			getTimeFormatter({cellValue}){
				if(cellValue == null){
					return "";
				}else{
					let date = new Date(cellValue);
					return this.Config.formatDate(date);
				}
			},
			showView(theRow) {
				this.showFlag = true;
				this.queryNBCommand(theRow.collectorAddr);
			},
			queryNBCommand(collectorAddr){
				this.loading = true;
				let param = {collectorAddr:collectorAddr};
				let url = this.Api.getLastUrl(this.Api.QUERY_NB_COLLECTOR_COMMAND_URL);
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.loading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.list = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
					this.loading = false;
				});
			}
		},
	}
</script>

<style>
</style>
